import { cssUtil } from "../utils/cssUtil";
import { getBaseStyles } from "./commonStyles";

export function renderHtmlWidget(context, widget, parent) {

    const device = widget?.properties?.desktop;
    const content = widget?.content;

    if (!content || !content.processedHtml) {
        return;
    }

    // Wrapper
    const element = context.document.createElement("div");
    element.classList.add("widget", "html_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = getBaseStyles(widget, breakpoint);
    element.setAttribute("style", cssUtil.toStyleString(styles));
    element.setAttribute("data-widgetId", widget.uid);
    element.setAttribute("data-widgetType", widget.type);
    element.setAttribute("data-widgetParent", widget.parent);

    // Content container
    const htmlContainer = context.document.createElement("div");
    htmlContainer.classList.add("html_widget__content");

    /**
     * processedHtml is assumed to be:
     *  - sanitized
     *  - safe
     *  - already resolved (cdn paths, etc.)
     */
    htmlContainer.innerHTML = content.processedHtml;

    element.appendChild(htmlContainer);
    parent.appendChild(element);
}